var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M0 15h18v3H0z M13.38 5.5L10.5 2.62 3 10.12V13h2.88l7.5-7.5zm2.47-2.48c.2-.2.2-.51 0-.71L13.68.14c-.2-.2-.51-.2-.71 0L11.62 1.5l2.88 2.88 1.35-1.36z"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f9edba0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/iconBorderColor.vue
// module id = null
// module chunks = 